import { Component, ElementRef, Renderer2, ChangeDetectorRef } from '@angular/core';
import { PONodeComponent } from '../abstract-classes/po-node/ponode.component';
import { ArrangementNodeComponent } from '../arrangement-node/arrangement-node.component';
import { ListOfAdminCodes } from '../abstract-classes/po-node/list-of-admin-codes';
import { DetailScreensService } from '../detail-screens-module/services/detail-screens-service';
import { DomService } from '../../../services/dom-service/dom.service';
import { ProductOverviewService } from '../../../services/product-overview/product-overview.service';
import { ArrangementLevelComponent } from '../abstract-classes/arrangement-level/arrangement-level.component';
import { SpecificsLabelWrapper } from '../abstract-classes/po-node/specifics-label-wrapper.model';
import { SpecificsLabel } from '../abstract-classes/po-node/specifics-label.model';
import { ToasterService } from '../../../toaster-module/toaster-service/toaster.service';
import { PopupService } from '../popup-component/popup.service/popup.service';
import { UiHelperService } from '../../../services/shared/helpers/ui-helper.service';

@Component({
  selector: 'app-expired-node',
  templateUrl: '../abstract-classes/arrangement-level/arrangement-level.component.html',
  styleUrls: ['../abstract-classes/po-node/ponode.component.css'],
})
export class ExpiredNodeComponent extends ArrangementLevelComponent {

  nodeType = 'expired-node';
  expandable = true;
  private listOfAdminCodes: string[] = ListOfAdminCodes;

  constructor(domService: DomService, private productOverviewService: ProductOverviewService,
              private el: ElementRef, private renderer: Renderer2, private changeRef: ChangeDetectorRef,
              detailsScreenService: DetailScreensService, toasterService: ToasterService, popupService: PopupService,
              protected uiHelper: UiHelperService) {
    super(domService, detailsScreenService, toasterService, popupService, uiHelper);
    this.expanded = false;
  }

  onClick() {
    super.onClick();
    if (!this.childrenInitialized) {
      this.initializeChildren();
    }
  }

  expand() {
    super.expand();
    if (!this.childrenInitialized) {
      this.initializeChildren();
    }
    this.children.forEach((child) => {
      child.expand();
    });
  }

  private initializeChildren(): void {
    // Ensure it's a valid array
    if (!Array.isArray(this.children)) {
      this.children = [];
    }

    this.hierarchyChildren.forEach((childData) => {
      const component = this.createComponent(childData, ArrangementNodeComponent);
      if (component) {
        this.children.push(component);
      }
    });

    const lastChild = this.children[this.children.length - 1];
    if (lastChild) {
      lastChild.isLastChild = true;
    }

    this.changeRef.detectChanges();
    this.getListOfDetailsForArrangements(this.children);
    this.childrenInitialized = true;
  }

  private getListOfDetailsForArrangements(children: ArrangementLevelComponent[]) {
    const arrangementList = [];
    children.forEach((arrangementNode) => {
      arrangementNode.data.restrictedDataViewException = this.data.restrictedDataViewException;
      if (this.listOfAdminCodes.includes(arrangementNode.data.administrationCode as string)) {
        arrangementList.push(
          {
            administrationCode: arrangementNode.data.administrationCode,
            arrangementNumber: arrangementNode.data.arrangementNumber,
          },
        );
      }
    });
    if (arrangementList.length !== 0 ) {
      this.productOverviewService.getDetails(arrangementList, this).subscribe(
        (resp) => {
          const listOfArrangementDetails = resp;
          if (listOfArrangementDetails) {
            this.setArrangementDetails(listOfArrangementDetails, children);
            this.changeRef.detectChanges();
          }
        });
    }
  }

  private setArrangementDetails(listOfArrangementDetails, children: ArrangementLevelComponent[]) {
    listOfArrangementDetails.forEach((detail) => {
      children.forEach((childArrangementNode) => {
        if ((childArrangementNode.data.arrangementNumber === detail['arrangementNumber'] ||
            childArrangementNode.data.arrangementNumber === detail['arrangementNumber'] + detail['currencyCode']) &&
          childArrangementNode.data.administrationCode === detail['administrationCode']) {
          childArrangementNode.data.restrictedData = detail['restrictedData'];
          childArrangementNode.data.specifics = detail['specifics'];
          childArrangementNode.data.specificsLabels = this.getSpecificsLabelsFromResponse(detail);
          childArrangementNode.data.abb = detail['abb'];
          childArrangementNode.data.totalAmount = detail['totalAmount'];
          childArrangementNode.data.totalAmountSuffix = detail['totalAmountSuffix'];
          childArrangementNode.data.count = '';
        }
      });
    });
  }

  private getSpecificsLabelsFromResponse(arrangementDetails): string {
    const labelsFromResponse: any[] = arrangementDetails['specificsLabels'];
    let specificsLabelWrapper: SpecificsLabelWrapper;
    if (labelsFromResponse && labelsFromResponse.length > 0) {
      specificsLabelWrapper = new SpecificsLabelWrapper();
      labelsFromResponse.forEach((labelFromResponse) => {
        const specificsLabel: SpecificsLabel = new SpecificsLabel();
        specificsLabel.labelName = labelFromResponse['labelName'];
        specificsLabel.labelValue = labelFromResponse['labelValue'];
        specificsLabelWrapper.specificsLabels.push(specificsLabel);
      });
    }

    if (specificsLabelWrapper) {
      return specificsLabelWrapper.getAggregatedLabel();
    }
  }

}
